export default __webpack_public_path__ + "static/media/IconOperatoryRoomChannel.e8534853.svg";